var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.87269 2.04235C-0.484814 4.4911 -0.0023144 7.09235 -0.0023144 14.9949C-0.0023144 21.5574 -1.14731 28.1361 4.84519 29.6849C6.71644 30.1661 23.2964 30.1661 25.1652 29.6824C27.6602 29.0386 29.6902 27.0149 29.9677 23.4861C30.0064 22.9936 30.0064 7.00485 29.9664 6.50235C29.6714 2.7436 27.3577 0.577346 24.3089 0.138596C23.6102 0.0373456 23.4702 0.00734562 19.8852 0.00109562C7.16893 0.00734562 4.38144 -0.558905 1.87269 2.04235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9992 3.92475C10.4605 3.92475 6.15047 3.521 4.50422 7.746C3.82422 9.491 3.92297 11.7572 3.92297 15.0022C3.92297 17.8497 3.83172 20.526 4.50422 22.2572C6.14672 26.4847 10.4917 26.0797 14.9967 26.0797C19.343 26.0797 23.8242 26.5322 25.4905 22.2572C26.1717 20.4947 26.0717 18.2622 26.0717 15.0022C26.0717 10.6747 26.3105 7.881 24.2117 5.7835C22.0867 3.6585 19.213 3.92475 14.9942 3.92475H14.9992ZM14.0067 5.921C23.4742 5.906 24.6792 4.8535 24.0142 19.4747C23.778 24.646 19.8405 24.0785 15.0005 24.0785C6.17547 24.0785 5.92172 23.826 5.92172 14.9972C5.92172 6.066 6.62172 5.926 14.0067 5.9185V5.921ZM20.9117 7.75975C20.178 7.75975 19.583 8.35475 19.583 9.0885C19.583 9.82225 20.178 10.4172 20.9117 10.4172C21.6455 10.4172 22.2405 9.82225 22.2405 9.0885C22.2405 8.35475 21.6455 7.75975 20.9117 7.75975ZM14.9992 9.3135C11.858 9.3135 9.31172 11.861 9.31172 15.0022C9.31172 18.1435 11.858 20.6897 14.9992 20.6897C18.1405 20.6897 20.6855 18.1435 20.6855 15.0022C20.6855 11.861 18.1405 9.3135 14.9992 9.3135ZM14.9992 11.3097C19.8805 11.3097 19.8867 18.6947 14.9992 18.6947C10.1192 18.6947 10.1117 11.3097 14.9992 11.3097Z",
    fill: "#3377EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.34879e31958fffa36e1ab81d4444955d.svg";
export { ForwardRef as ReactComponent };